<script setup lang="ts">
import type { Citation } from '../types'

defineProps<{
  citations: Citation[]
  compact?: boolean
}>()
</script>

<template>
  <div v-if="citations.length" class="citation-list" :class="{ compact }">
    <div
      v-for="citation in citations"
      :key="`${citation.source_id}-${citation.chapter}`"
      class="citation-item"
    >
      <span class="citation-id">{{ citation.source_id }}</span>
      <span>
        <strong>{{ citation.book }}</strong>
        <span> · {{ citation.chapter }}</span>
        <span v-if="citation.page_start">
          · 第 {{ citation.page_start }}–{{ citation.page_end }} 页
        </span>
      </span>
    </div>
  </div>
</template>

